import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {UserRouteAccessService} from './core/auth/user-route-access-service';

const routes: Routes = [
  {
    path: '',
    canActivate: [UserRouteAccessService],
    loadChildren: './main/main.module#MainModule'
  },
  {
    path: 'account',
    loadChildren: './account/account.module#AccountPageModule'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
